// TODO: move this directive to external dop angular library

import { Directive, ElementRef, Renderer2, OnInit, OnChanges, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
    selector: '[appCustomVirtualScroller]'
})
export class CustomVirtualScrollerDirective implements OnInit, OnChanges {

    constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

    @Input() scrollElementRef: any;
    @Output() scrollDown = new EventEmitter<any>();

    scrollUpdate = new Subject<any>();

    ngOnInit() {
        this.scrollElementRef?.addEventListener('scroll', this.onScroll.bind(this));
        this.scrollUpdate.pipe(
            debounceTime(400),
            distinctUntilChanged())
            .subscribe(event => {
                let lastScrollTop = 0;
                if (event.target.scrollTop > lastScrollTop) {
                    if (Math.floor(event.target.scrollHeight - event.target.scrollTop) <= Math.floor(event.target.offsetHeight)) {
                        this.scrollDown.emit();
                    }
                }
                lastScrollTop = event.target.scrollTop <= 0 ? 0 : event.target.scrollTop;
            });
    }

    ngOnChanges(): void {
        this.scrollElementRef?.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll(event: any) {
        this.scrollUpdate.next(event);
    }
}
